import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import DoneIcon from "@mui/icons-material/Done";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import PendingIcon from "@mui/icons-material/Pending";

import CustomButton from "../../helper-components/input/CustomButton";

import { defaultId, defaultStatus, defaultStyle, defaultTime } from "./shared.js";
import { formatText } from "../shared/miscUtils.js";

// Render functions.
const renderStatus = (params) => {
    const status = params.row.status;
    const formatted = formatText(status);

    if (status === "ACTIVE") {
        return <CustomButton icon={<DoneIcon className="cursor-default" />} tooltip={formatted} />;
    } else if (status === "INACTIVE") {
        return <CustomButton icon={<PendingIcon className="cursor-default" />} tooltip={formatted} />;
    } else if (status === "REMOVED") {
        return <CustomButton icon={<RemoveCircleOutlineIcon className="cursor-default" />} tooltip={formatted} />;
    }

    return <CustomButton icon={<QuestionMarkIcon className="cursor-default" />} tooltip={formatted} />;
};

// Column definitions.
const username = { ...defaultStyle, field: "username", headerName: "Username", flex: 0.15, minWidth: 100 };
const email = { ...defaultStyle, field: "email", headerName: "Email", flex: 0.2, minWidth: 200 };
const status = { ...defaultStatus(), renderCell: (params) => renderStatus(params) };
const role = { ...defaultStyle, field: "role.role", headerName: "Role", minWidth: 125, valueGetter: (params) => formatText(params.row.role?.role) };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const lastLogin = { ...defaultTime("last_login"), headerName: "Last login" };

// Table columns.
export const columns = (props) => [defaultId, username, email, status, role, createdOn, lastLogin];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
